import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.125}
      d="M15 15.75H3M12 3a1.989 1.989 0 0 0 2.25 2.25m-9 6.75.428-1.71c.12-.48.18-.72.276-.944a3 3 0 0 1 .319-.563c.142-.198.317-.373.667-.723l5.435-5.435a1.5 1.5 0 0 1 2.134-.114c.027.024.056.054.116.114v0a1.5 1.5 0 0 1 .114 2.134 3.805 3.805 0 0 1-.114.116L9.19 10.31c-.35.35-.525.525-.723.667a3.002 3.002 0 0 1-.563.319c-.224.096-.464.156-.944.277L5.25 12Z"
    />
  </svg>
)
export default SvgComponent
